import PropTypes from "prop-types";
import classNames from "classnames";
import { asIcon } from "../utils/library";

const Chevron = ({
    className,
    width = "10px",
    height = "10px",
    isDecorative,
    points,
    type,
}) => {
    const classes = classNames("chevronIcon", points, className);

    const newProps = {
        className: classes,
        width,
        height,
        ...(isDecorative
            ? { role: "presentation" }
            : { "aria-label": type, "aria-hidden": true }),
    };
    return (
        <svg
            viewBox="0 0 10 10"
            focusable="false"
            {...newProps}
            data-testid="chevron-svg"
        >
            <g>
                <path d="M10,0v3L5,7L0,3V0l5,4L10,0z" />
            </g>
        </svg>
    );
};

Chevron.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    points: PropTypes.string,
    isDecorative: PropTypes.bool,
};

const IconChevron = asIcon(Chevron);
export { IconChevron, Chevron };
